import { render } from "./PrizeButtonBar.vue?vue&type=template&id=05aaee7f"
import script from "./PrizeButtonBar.vue?vue&type=script&lang=js"
export * from "./PrizeButtonBar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Apps/sendcloudholidaygiftsraffle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__